import React, { useState, useRef, useEffect, useReducer } from 'react'
import { useSelector } from 'react-redux'
import RateResponse from './RateResponse'

import './IAAgent.less'
import { actionDispacher } from './IAAgentModule'
import useAccount from '@hooks/useAccount'
import useClientConfig from 'config/clients/useClientConfig'
import { useLocation } from 'react-router-dom'

type Message = {
    role: 'user' | 'assistant'
    content: string
    session: string
    tenant: string
    item?: number
    userLogin: string
}

interface AIAgentProps { }



const AIAgent: React.FC<AIAgentProps> = (props: AIAgentProps) => {

    const account = useAccount()
    const userProfiles = account?.userProfiles
    const authorities = account?.authorities
    const login = account?.login

    const { getAssistantConfig } = useClientConfig()
    const buttonText = getAssistantConfig()?.buttonText
    const tenant = getAssistantConfig()?.tenant

    const { pathname } = useLocation()

    const iaType: 'full' | 'button' = pathname !== '/ia-agent' ? 'button' : 'full'

    const [messages, setMessages] = useState<Message[]>([])
    const [input, setInput] = useState('')
    const [open, setOpen] = useState(iaType === 'full')
    const [session, setSession] = useState('')
    const [item, setItem] = useState<number | undefined>(undefined)
    const messagesEndRef = useRef<HTMLDivElement>(null)

    //const dispatcher = actionDispacher()
    const dispatcherRef = useRef(actionDispacher());

    const openChat = () => setOpen(true)
    const closeChat = () => setOpen(false)

    //test
    //const [, forceRerender] = useReducer(x => x + 1, 0)

    const isSendingRef = useRef(false)

    const { waitingResponse, data } = useSelector(
        (state: {
            iaAgent: { waitingResponse: boolean, data: any }
        }) => state.iaAgent
            || { waitingResponse: false, data: null, session: '', item: undefined }
    )

    useEffect(() => {
        //console.log("useEffect 1")
        //console.log(data)
        if (data && data.content) {

            isSendingRef.current = false

            const assistantMessage: Message = {
                role: 'assistant',
                content: data.content,
                session: data.session || '',
                tenant: tenant,
                item: data.itemId ?? 0,
                userLogin: login
            }
            setMessages((prev) => [...prev, assistantMessage])
            setSession(data.session)
            setItem(assistantMessage.item)
        }
    }, [data])

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
    }, [messages])

    const handleSendMessage = () => {

        //console.log("handleSendMessage")
        //console.log(waitingResponse)
        //console.log(isSendingRef.current)
        //console.trace("Disparando mensaje")
        if (!input.trim() || waitingResponse || isSendingRef.current) return

        isSendingRef.current = true

        const userMessage: Message = {
            role: 'user',
            content: input,
            session: session ?? '',
            tenant: tenant,
            item: undefined,
            userLogin: login,
        }
        setMessages((prev) => [...prev, userMessage])
        setInput('')
        setItem(undefined)
        //console.log("dispatching sendMessage")
        dispatcherRef.current.sendMessage({
            query: input,
            tenant: tenant,
            userLogin: login,
            ...(session && { session })
        })
    }

    const assistantEnabledProfile = userProfiles?.some(
        profile => profile?.config?.access?.["chat-assistant"]
    ) ?? false;

    const assistantEnabledRole = authorities?.includes('ROLE_IA_ASSISTANT') ?? false;

    if (!assistantEnabledProfile
        && !assistantEnabledRole
        && !getAssistantConfig()?.enable) {
        return <></>
    }

    //console.log("🌀 Componente renderizado")
    //console.log(props)
    //console.log(pathname)

    return (<>
        {
            iaType === 'button'
            && <div className="chat-button-wrapper">
                <button className="chat-button" onClick={open ? closeChat : openChat}>
                    {open ? '✖' : buttonText}
                </button>
            </div>
        }
        {open && (
            <div className={iaType === 'button' ? 'chat-modal-overlay' : 'chat-screen-overlay'}>
                <div className={iaType === 'button' ? 'chat-modal' : 'chat-screen'}>
                    <div className="chat-box">
                        <div className="messages-container">
                            {messages.map((msg, index) => {
                                return (
                                    <div
                                        id={`chat-message-${index}`}
                                        className={`chat-message ${msg.role === 'user' ? 'user' : 'assistant'}`}
                                    >
                                        {msg.content}
                                        <RateResponse
                                            display={messages.length - 1 === index
                                                && msg.role === 'assistant'
                                                && session !== undefined
                                                && item !== undefined}
                                            tenant={tenant}
                                            session={session}
                                            item={item}
                                            userLogin={login} />
                                    </div>
                                )
                            })}

                            {waitingResponse && (
                                <div className="chat-message assistant">💬 Pensando...</div>
                            )}
                            <div ref={messagesEndRef} />
                        </div>

                        <div className="chat-input">
                            <textarea
                                rows={1}
                                placeholder="Escribe tu mensaje..."
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                className="chat-textarea"
                            />
                            <button onClick={handleSendMessage} disabled={waitingResponse || !input.trim() || isSendingRef.current}>
                                Enviar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </>)
}

export default AIAgent
